module.exports = __webpack_public_path__ + "img/Monthly Scheduler.298dbe15.png";